import "core-js/modules/es.array.concat.js";
import styles from "./QuoteCard.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var initQuote = /*#__PURE__*/_jsx("svg", {
  width: "65",
  height: "53",
  viewBox: "0 0 65 53",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    d: "M0 38.7953C0 36.6115 1.26247 32.9265 3.7874 27.7402L17.6063 0H28.7638L18.7323 26.4094C21.2572 27.2966 23.2362 28.9003 24.6693 31.2205C26.1706 33.4724 26.9213 35.9974 26.9213 38.7953C26.9213 42.5486 25.6247 45.7218 23.0315 48.315C20.4383 50.9081 17.231 52.2047 13.4094 52.2047C9.65617 52.2047 6.48294 50.9423 3.88976 48.4173C1.29659 45.8241 0 42.6168 0 38.7953ZM36.3386 38.7953C36.3386 36.6115 37.6011 32.9265 40.126 27.7402L53.9449 0H65L55.1732 26.4094C57.5617 27.3648 59.4724 28.9685 60.9055 31.2205C62.4068 33.4724 63.1575 35.9974 63.1575 38.7953C63.1575 42.6168 61.895 45.8241 59.3701 48.4173C56.8451 50.9423 53.6378 52.2047 49.748 52.2047C45.9265 52.2047 42.7192 50.9423 40.126 48.4173C37.6011 45.8241 36.3386 42.6168 36.3386 38.7953Z",
    fill: "currentColor"
  })
});
var endQuote = /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "16",
  viewBox: "0 0 19 16",
  fill: "none",
  children: /*#__PURE__*/_jsx("path", {
    d: "M8.40787 4.1098C8.40787 4.84183 8.03885 6.00261 7.30079 7.59216L3.26142 16H0L2.9622 7.90588C2.22415 7.61307 1.6357 7.13203 1.19685 6.46275C0.777953 5.79346 0.568504 5.00915 0.568504 4.1098C0.568504 2.93856 0.937533 1.96601 1.67559 1.19216C2.4336 0.397386 3.37113 0 4.48819 0C5.60525 0 6.53281 0.397386 7.27087 1.19216C8.02887 1.96601 8.40787 2.93856 8.40787 4.1098ZM19 4.1098C19 4.96732 18.631 6.1281 17.8929 7.59216L13.8535 16H10.6819L13.5543 7.90588C12.8362 7.61307 12.2577 7.13203 11.8189 6.46275C11.3801 5.77255 11.1606 4.98824 11.1606 4.1098C11.1606 2.93856 11.5297 1.96601 12.2677 1.19216C13.0257 0.397386 13.9633 0 15.0803 0C16.1974 0 17.1249 0.397386 17.863 1.19216C18.621 1.96601 19 2.93856 19 4.1098Z",
    fill: "currentColor"
  })
});
export var QuoteCard = function QuoteCard(_ref) {
  var text = _ref.text,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 1 : _ref$level,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'dietitians' : _ref$type,
    backgroundImageUrl = _ref.backgroundImageUrl,
    _ref$buttonLabel = _ref.buttonLabel,
    buttonLabel = _ref$buttonLabel === void 0 ? '' : _ref$buttonLabel;
  var levelClass = level === 1 ? styles.level1 : level === 2 ? styles.level2 : styles.level3;
  var typeClass = type ? styles[type] : '';
  return /*#__PURE__*/_jsxs("div", {
    className: "".concat(styles.root, " ").concat(levelClass, " ").concat(typeClass, " ").concat(backgroundImageUrl ? styles.hasBgImage : ''),
    style: backgroundImageUrl ? {
      '--bg-image': "url(".concat(backgroundImageUrl, ")")
    } : undefined,
    "data-hasbg": backgroundImageUrl ? 'true' : 'false',
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.quoteStart,
      children: initQuote
    }), /*#__PURE__*/_jsx("p", {
      className: styles.text,
      children: text
    }), /*#__PURE__*/_jsx("div", {
      className: styles.quoteEnd,
      children: endQuote
    }), /*#__PURE__*/_jsx("button", {
      className: styles.button,
      "aria-label": "button-label",
      children: buttonLabel
    })]
  });
};